import React, { useEffect } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { StudentResults } from './student-result';
import { TabNavigation } from './tab-navigation';
import i18next from './locale/i18n';
function useArrayRef() {
    const refs = [];
    return [refs, (element) => element && refs.push(element)];
}
export const ResultList = (props) => (React.createElement(I18nextProvider, { i18n: i18next },
    React.createElement(ResultListContent, { language: props.language, resultList: props.resultList, studentBaseUrl: props.studentBaseUrl })));
const ResultListContent = (props) => {
    const { t, i18n } = useTranslation();
    const [sectionRefs, setSectionRef] = useArrayRef();
    const { resultList, language, studentBaseUrl } = props;
    useEffect(() => {
        void i18n.changeLanguage(language);
    }, [i18n, language]);
    return (React.createElement("div", { className: "result-list-component-container" },
        React.createElement(TabNavigation, { resultList: resultList, sectionRefs: sectionRefs }),
        resultList.map(resultListGroup => (React.createElement("div", { key: resultListGroup.groupName },
            React.createElement("h1", { id: resultListGroup.groupName, ref: setSectionRef },
                t(`results.groups.${resultListGroup.groupName}.title`),
                " (",
                resultListGroup.students.length,
                ")"),
            React.createElement("div", { className: "description" }, t(`results.groups.${resultListGroup.groupName}.description`)),
            resultListGroup.students.map((student) => (React.createElement(StudentResults, { key: `${student.studentUuid || student.birthday}${resultListGroup.groupName}`, student: student, language: "fi", studentBaseUrl: studentBaseUrl }))))))));
};
//# sourceMappingURL=result-list.js.map